<div class="modal-header">
    <h4 class="modal-title" id="modal-title">
        <i class="{{headerIcon}} {{headerIconStyle}}"></i>{{headerTitle}}
    </h4>
    <button
        type="button"
        class="btn-close"
        aria-describedby="modal-title"
        (click)="cancel()"
    ></button>
</div>
<div class="modal-body">
    <p>
        <span [innerHTML]="subtitleText"></span> <strong class="text-info" *ngIf="whatToDelete">"{{whatToDelete}}"</strong> ?
    </p>
    <p>
        {{bodyText1}}
        <span class="text-danger">{{bodyText2}}</span>
    </p>
    <div *ngIf="footerWarning" class="alert alert-warning mt-3 mb-0" role="alert">
        {{ footerWarning }}
    </div>
    <div *ngIf="requireConfirmCheckbox" class="form-check mt-3">
        <input
            class="form-check-input"
            type="checkbox"
            id="confirmDialogCheckbox"
            [checked]="confirmChecked"
            (change)="confirmChecked = $any($event.target).checked"
        />
        <label class="form-check-label" for="confirmDialogCheckbox">
            {{ confirmCheckboxLabel }}
        </label>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn {{btnStyle2}}" (click)="cancel()">{{btnText2}}</button>
    <button type="button" class="btn {{btnStyle}}" [disabled]="!canConfirm" (click)="confirm()">{{btnText}}</button>
</div>
